import { render } from "./CadastroTipoClienteView.vue?vue&type=template&id=6953ae73"
import script from "./CadastroTipoClienteView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoClienteView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__